const riot = require('riot');
riot.tag2('editmeasure', '<div class="measure is-clearfix {expandable:expandable}"> <div class="field is-pulled-right"> <input type="checkbox" name="prop-{m.id}" id="prop-{m.id}" class="switch {is-outlined:active_children,is-info:checked && mode==\'should\',is-danger:checked && mode==\'not\'}" checked="{checked}" onclick="{toggleProperty}"><label for="prop-{m.id}"></label> </div> <div class="field is-pulled-right is-grouped" if="{opts.p.id==24 && checked}"> <input ref="freq" name="prop-{m.id}-freq" id="prop-{m.id}-freq" class="input is-small" riot-value="{freq}" style="width:50px" onchange="{setField}" type="{\'number\'}"><label for="prop-{m.id}-freq"></label> <div class="select is-small"> <select name="customer" name="prop-{m.id}-mode" ref="mode" onchange="{setField}" riot-value="{mode}"> <option>should</option> <option>must</option> <option>not</option> </select> </div> </div> <div if="{!expandable}"> <span class="icon is-small has-text-grey is-marginless"><i class="fa fa-fake"></i></span> {m.name} </div> <div if="{expandable}" onclick="{toggleExpand}"> <span class="icon is-small is-marginless"><i class="fa {fa-caret-right:!expanded,fa-caret-down:expanded}"></i></span> {m.name} </div> </div> <ul if="{expanded}" class="is-list"> <virtual each="{c in m.children}" c="{c}"> <li data-is="editmeasure" m="{c}" p="{opts.p}" r="{opts.r}" if="{c.active}" ref="child"></li> </virtual> </ul>', '', '', function(opts) {
  const self = this,
        r = opts.r

  self.m = opts.m

console.log('PROP',opts.r)

  self.expandable = !!opts.m.children.length
  self.properties = self.parent.properties
  self.checked = self.properties.indexOf(self.m.id)>-1
  self.profile = self.parent.profile
  self.active_nodes = self.parent.active_nodes
  self.active_children = self.active_nodes[self.m.id] || 0

  this.checkRootline = function(status,diff) {
    if (self.parent.checkRootline) {
      const m = self.parent.m,
            profile = self.profile,
            props = self.properties,
            idx = props.indexOf(m.id),
            state = self.parent.checked
      if (status) {
        self.parent.checked = false

        console.log('removing',m)
        if (idx > -1) props.splice(idx,1)
        if (profile[m.field]) {
        	profile[m.field] = profile[m.field].filter(mes => mes!=m.label)
        	if (!profile[m.field].length) delete profile[m.field]
        }
        self.parent.active_children += diff
        self.active_nodes[self.parent.m.id] +=diff
        self.parent.checkRootline(status,state ? 0 : diff)
      } else {
        self.parent.active_children--
        self.active_nodes[self.parent.m.id]--
        self.parent.checkRootline(status,diff)
      }
    } else {
      self.update()
      self.parent.parent.refreshNeeded++
      self.parent.parent.update()
    }
  }.bind(this)
  this.checkChildren = function(status) {
console.log('children',self.refs)
    if (status && self.refs.child) {
      self.refs.child.forEach(c => {
        if (!(c.checked || c.active_children)) return
        const m = c.m,
              profile = self.profile,
              props = self.properties,
              idx = props.indexOf(m.id)
        if (c.checked) {
          c.checked = false
  console.log('checking',c)

          if (idx > -1) props.splice(idx,1)
          if (profile[m.field]) {
          	profile[m.field] = profile[m.field].filter(mes => mes!=m.label)
          	if (!profile[m.field].length) delete profile[m.field]
          }
        }
        self.active_children--
        self.active_nodes[self.m.id]--
        c.checkChildren(status)
      })
    }
  }.bind(this)

  function getField(fld) {
    const m = self.m,
          p = opts.p,
          prop = m.id,
          p_label = m.field,
          m_label = m.label,
          label = self.profile[p_label] && self.profile[p_label].find(l => l.label==m_label) || null
console.log('FIELD',fld,self.profile[p_label])
    return label && label[fld] || ''
  }
  self.on('update',function() {
    if (opts.p.id==24) {
      self.mode = getField('mode')
      self.freq = getField('freq')
    }
  })

  this.setField = function(e) {
    const t = e.target,
          fld = t.getAttribute('ref'),
          m = self.m,
          p = opts.p,
          prop = m.id,
          p_label = m.field,
          m_label = m.label,
          label = self.profile[p_label].find(l => l.label==m_label)
    label[fld] = self.refs[fld].value
console.log('STORING',r,fld,self.profile[p_label])
    r.parent.refreshNeeded++
    r.parent.update()
    self[fld] = label[fld]

  }.bind(this)

  this.toggleProperty = function(e) {
    const m = self.m,
          p = opts.p,
          prop = m.id,
          p_label = m.field,
          m_label = m.label,
          props = self.properties,
          profile = self.profile,
          active = self.active_children
    let idx = props.indexOf(prop)

    console.log('Before parent', self.parent, idx)
    if (profile[p_label]) {
      if (p.id==24) profile[p_label] = profile[p_label].filter(mes => mes.label!=m_label)
      else profile[p_label] = profile[p_label].filter(mes => mes!=m_label)
    	if (!profile[p_label].length) delete profile[p_label]
    }
    if (idx>-1) {
      self.checked = false
      props.splice(idx,1)
    } else {
      self.checked = true
      idx = 0
      while (props[idx] < prop) idx++
      props.splice(idx,0,prop)
      if (!profile[p_label]) profile[p_label] = []
      if (p.id==24) profile[p_label].push({label:m_label,mode:'should',freq:3})
	    else profile[p_label].push(m_label)
    }
    self.parent.update()
    self.checkChildren(self.checked)
    self.checkRootline(self.checked,1-active)
    console.log('PARENT profile', profile)
    console.log('PARENT properties', self.parent.properties)
  }.bind(this)

  this.toggleExpand = function(e) {
    if (!self.expandable) return
    self.expanded = !self.expanded
    self.update()
  }.bind(this)
});

riot.tag2('proptable', '<small> <a href="#" onclick="{toggleExpand}"><span if="{expanded}">hide</span><span if="{!expanded}">show</span></a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <a href="#" onclick="{download}">download as CSV</a> <virtual if="{percent_cell}">/ <a href="#" onclick="{download_percent}">as CSV (%)</a></virtual> </small> <table if="{columns}" class="table"> <thead if="{expanded}"> <tr> <th each="{col, idx in columns}"> {col} <div> <i class="fas fa-angle-up is-pointer is-hover-red {has-text-info:parent.sort_col==idx+1}" onclick="{dosort(idx,1)}"></i> <i class="fas fa-angle-down is-pointer is-hover-red {has-text-info:parent.sort_col==-(idx+1)}" onclick="{dosort(idx,-1)}"></i> </div> </th> <th if="{percent_col}"> {percent_col.label} <div> <i class="fas fa-angle-up is-pointer is-hover-red {has-text-info:sort_col==\'+p\'}" onclick="{dosortShare(1)}"></i> <i class="fas fa-angle-down is-pointer is-hover-red {has-text-info:sort_col==\'-p\'}" onclick="{dosortShare(-1)}"></i> </div> </th> <th if="{opts.sum_rows}">Total</th> </tr> </thead> <tbody if="{expanded}"> <tr each="{row, ridx in rows}"> <td each="{col, cidx in columns}" class="{has-text-right:cidx}"> <div><raw html="{row[cidx]}"></raw></div> <div class="is-size-7 has-text-grey" if="{percent_cell && cidx}" title="% of profiled visitors">{p_cell(row[cidx],cidx,ridx)}%</div> </td> <td if="{opts.sum_rows}" class="has-text-right"> <div>{rsum[ridx]}</div> <div class="is-size-7 has-text-grey" if="{percent_cell}" title="% of profiled visitors">{p_cell(rsum[ridx],cidx,ridx)}%</div> </td> <td if="{percent_col}" class="has-text-right is-size-7">{p_col(row,\'row\')}%</td> </tr> </tbody> <tfoot> <tr if="{opts.sum_cols && expanded}"> <td>Total</td> <td each="{col,cidx in csum}" class="has-text-right"> <div>{col}</div> <div class="is-size-7 has-text-grey" if="{percent_cell}" title="% of profiled visitors">{p_cell(col,cidx+1,null)}%</div> </td> <td if="{percent_col}" class="has-text-right">{p_col(csum,\'total\')}%</td> </tr> <tr if="{percent_row && expanded}" class="is-size-7"> <td>{percent_row.label}</td> <td each="{col,cidx in csum}">{p_row(cidx)}%</td> <td if="{opts.sum_rows}">{p_col(rsum,\'col\')}%</td> </tr> </tfoot> </table>', '', '', function(opts) {
  const self = this

  self.tabledata = opts.tabledata
  self.expanded = false

  this.toggleExpand = function(e) {
    e.preventDefault()
    self.expanded = !self.expanded
  }.bind(this)

  this.dosort = function(idx,ord) {
    return function(e) {

      e.preventDefault()
      self.sort_col = (idx+1)*ord
      console.log('sort_col',self.sort_col)
      self.rows.sort(function(a,b){
console.log('a/b',idx,ord,a,b)
        if (a[idx]>b[idx]) return ord
        if (a[idx]<b[idx]) return -ord
        return 0
      })
      self.update()
    }
  }.bind(this)

  this.dosortShare = function(ord) {
    return function(e) {

      e.preventDefault()
      self.sort_col = ord>0 ? '+p' : '-p'
      console.log('sort_col',self.sort_col)
      self.rows.sort(function(a,b){
console.log('a/b',ord,a,b)
        const aa = +self.p_col(a,'row'),
              bb = +self.p_col(b,'row')
        if (aa>bb) return ord
        if (aa<bb) return -ord
        return 0
      })
      self.update()
    }
  }.bind(this)

  this.p_cell = function(val,cidx,ridx) {

    const pc = self.tabledata.pcell_mode=='none'
               ? (100*(val/self.percent_cell)).toFixed(2)
               : self.tabledata.pcell_mode=='row'
               	 ? (100*(val/self.percent_cell[ridx])).toFixed(2)
               	 : (100*(val/self.percent_cell[cidx-1])).toFixed(2)
    return pc
  }.bind(this)

  this.p_col = function(r,mode) {
    if (mode=='total') r.unshift(0)
    const opt = mode=='col' ? self.percent_row : self.percent_col,
      all = +r[opt.all] || 0,
      sel = +r[opt.sel] || 0,
      p = all ? (100*(sel/all)).toFixed(2) : 0
    return p
  }.bind(this)

  this.p_row = function(idx) {
    const opt = self.percent_row,
      rows = self.rows

console.log('rows',rows)
console.log('opt',idx,opt)

    const
      all = +rows[opt.all][idx+1] || 0,
      sel = +rows[opt.sel][idx+1] || 0,
      p = all ? (100*(sel/all)).toFixed(2) : 0
    return p
  }.bind(this)

  function load_table(data) {
  console.log('TABLE',data)
    if (data && data.tabledata) self.tabledata = data.tabledata
    self.columns = self.tabledata.columns
    self.percent_cell = self.tabledata.percent_cell
    self.percent_col = self.tabledata.percent_col
    self.percent_row = self.tabledata.percent_row
    self.rows = self.tabledata.rows
    self.csum = self.columns.slice(1).map(c => 0)
    self.rsum = self.rows.map(c => 0)
    self.rows.forEach( (r,ridx) => {
      r.slice(1).forEach( (c,cidx) => {
        self.csum[cidx] += c||0
        self.rsum[ridx] += c||0
      })
    })
  }
  self.on('update',load_table)

  function saveAs (filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  this.download = function(e) {
    e.preventDefault()
    var p = self.parent,
        file = p.name+'_'+opts.prop+'_'+p.dtstart.toISODate()+'-'+p.dtend.toISODate()+'.csv',
        data = [self.columns,...self.rows]
    data = data.map(r => ['"' + r.join('","') + '"'])
    data = data.join('\n')

    saveAs(file,data);
  }.bind(this)

  this.download_percent = function(e) {
    e.preventDefault()
    console.log('doing percent',self)
    var p = self.parent,
        file = p.name+'_'+opts.prop+'_'+p.dtstart.toISODate()+'-'+p.dtend.toISODate()+'_percent.csv',
        prows = self.rows.map((r,ridx) => r.map( (c,cidx) => cidx ? self.p_cell(c,cidx,ridx) : c )),
        data = [self.columns,...prows]
    data = data.map(r => ['"' + r.join('","') + '"'])
    data = data.join('\n')

    saveAs(file,data);
  }.bind(this)

});

import * as echarts from 'echarts/core'
import {BarChart, LineChart, MapChart} from 'echarts/charts'
import {GeoComponent,VisualMapComponent,TooltipComponent,GridComponent,LegendComponent } from 'echarts/components'
import geojson from '../../assets/Statisticne_regije.json'
import iab_parse from '../../assets/iab_parser.js'
import './raw.tag'
riot.tag2('audience', '<div class="card is-collapse {is-print:expanded}"> <header class="card-header {has-background-light:expanded}" onclick="{toggleExpand}"> <div class="card-header-title" style="display:block;font-weight:normal;padding:0.25rem 0.5rem"> <strong>{name}</strong> <a onclick="{setCustomerFilter(customer_id)}"><small>{customer_obj && customer_obj.name || customer_id}</small></a> <br><small>Campaigns: {campaigns?.length}, Routes: {routes?.length}, <small>{sites?.join(\'\\n\')}</small> </div> <div class="card-header-icon" style="padding:1rem 0.5rem;"> <button if="{expanded}" class="button is-small no-print {primary:is_print}" style="margin:0 0.75em" onclick="{togglePrint}">Print</button> <span if="{stats}"><i class="fas fa-archive"></i> <small>{(new Date(dtstart)).toISODate()} - {(new Date(dtend)).toISODate()}</small></span> <a href="#" onclick="{toggleExpanded}" aria-label="more options"> <span class="icon"> <i class="fas {fa-angle-down:!expanded,fa-angle-up:expanded}" aria-hidden="true"></i> </span> </a> </div> </header> <div if="{expanded}" class="card-content has-margin has-background-white-bis" style="margin-bottom:1rem"> <form> <div class="columns"> <div class="column {is-one-third:!manual}"> <div class="field control"> <label for="name" class="label">ID</label> <span>{_id}</span> </div> <div class="field control"> <label for="name" class="label">Name</label> <input class="input" type="text" riot-value="{name}" name="name" ref="name"> </div> <div class="field control"> <label for="name" class="label">Keyword</label> <input class="input" type="text" riot-value="{keyword}" name="keyword" ref="keyword"> </div> <div class="field control"> <label for="customer" class="label">Customer</label> <div class="control" style="flex-shrink:1"> <div class="select is-small"> <select name="customer" ref="customer"> <option value="">Select customer</option> <option each="{customers}" riot-value="{_id}" selected="{_id==parent.customer_id}">{name}</option> </select> </div> </div> </div> <div class="field control"> <label for="sites" class="label">Sites</label> <textarea name="sites" rows="{sites.length + 2}" ref="sites" onchange="{setSites}" class="textarea">{sites.join(\'\\n\')}</textarea> </div> <div class="field control"> <label for="sites" class="label">Campaigns</label> <div each="{campaign in campaigns}" class="{red:campaign.customer_id!=customer_id}"><a href="#/targeting/{campaign._id}" title="customer: {campaign.customer_id}" target="_blank">{campaign.name}</a></div> </div> <div class="field control"> <label for="sites" class="label">Routes</label> <div each="{route in routes}" class="{red:route.campaign.customer_id!=customer_id}"><a href="#/targeting/{route.campaign._id}" title="customer: {route.campaign.customer_id}" target="_blank">{route.name}</a></div> </div> <div class="field control"> <label for="filter" class="label">Demography filter</label> <textarea rows="4" ref="filter" disabled="{!manual}" class="textarea" onchange="{setFilter}">{filter}</textarea> </div> <div class="field control"> <label for="iab_filter" class="label">Interest filter</label> <textarea rows="4" ref="iab_filter" disabled="{!manual}" class="textarea" onchange="{setBEXFilter}">{iab_filter}</textarea> </div> <div class="field control"> <input type="checkbox" id="manual" name="manual" ref="manual" class="switch is-info" onclick="{toggleManual}" checked="{manual}"><label for="manual">Manual filter</label> </div> </div> <div class="column is-two-thirds" if="{!manual}"> <div class="field control"> <div class="message is-card is-white" if="{prop.active}" each="{prop,pidx in allprops}"> <div class="message-header has-background-light toggle-next" onclick="{toggleNext}"> <div class="toggle-title">{prop.name}</div> <div class="tags"> <span class="tag is-info" each="{m,midx in prop.measures}" if="{properties.indexOf(m.id)>-1 && m.active}">{m.name}</span> </div> </div> <ul if="{Object.keys(prop.measures).length}" class="message-body has-margin is-hidden"> <li data-is="editmeasure" each="{m,midx in prop.measures}" if="{!m.parent && m.active}" m="{m}" p="{prop}" r="{parent}"></li> </ul> </div> </div> </div> </div> <div class="field is-grouped is-grouped-centered"> <div class="control"> <button class="button {is-info:!dirty,is-warning:dirty}" onclick="{saveAudience}">Save changes</button> </div><div class="control"> <button class="button is-light" onclick="{removeAudience}">Remove audience</button> </div> </div> <div class="demography"> <div class="column is-12"> <h4 class="title is-6">Audience overview</h4> <h5 class="subtitle is-6"> <strong if="{stats}">Showing stored data</strong> <strong if="{!stats}">Current data not stored</strong> </h5> <div class="columns"> <div class="column is-8"> <b>Visitors</b> {total_filtered} (selected) / {total_profiled} (profiled) / {total} (all) <br> <b>Pageviews</b> {pv_filtered} (selected) / {pv_profiled} (profiled) / {pv_total} (all) <br> </div> <div class="column is-4"> <div class="field"> <div class="control"> <label class="label">Adform</label> <p> {adform_filtered} (selected) / {adform_total} (all)</p> </div> <div class="control" style="margin:0.25rem"> <button if="{adform_status!=\'progress\'}" class="button is-small {is-warning:adform_status==\'dirty\'}" onclick="{fetchAdform}">Fetch adfrom IDs</button> <progress if="{adform_status==\'progress\'}" class="progress" style="margin:0.25rem" riot-value="{adform_done}" max="{adform_export}">{(100 * adform_done / adform_export).toFixed(2)}%</progress> </div> <div class="control" style="margin:0.25rem"> <a class="button is-small {is-info:adform_status==\'completed\',is-warning:adform_status!=\'completed\'}" href="{adform_file}"> download ({adform_done})</a> </div> </div> </div> </div> <br><br> <div class="field field is-grouped"> <div class="control"> <label class="label is-small">&nbsp;</label> <div class="select is-small"> <select onchange="{setCustomDates}" ref="dtcustom" riot-value="{dtcustom}"> <option value="custom">custom period</option> <option value="7" checked>last 7 days</option> <option value="15" checked>last 15 days</option> <option value="30">last 30 days</option> <option value="60">last 60 days</option> <option value="this_m">this month</option> <option value="prev_m">previous month</option> </select> </div> </div> <div class="control"> <label class="label is-small">from</label> <input class="input is-small" onchange="{setCustom}" placeholder="start date" ref="dtstart" riot-value="{dtstart.toISODate()}" type="{\'date\'}"> </div> <div class="control"> <label class="label is-small">to</label> <input class="input is-small" onchange="{setCustom}" placeholder="end date" ref="dtend" riot-value="{dtend.toISODate()}" type="{\'date\'}"> </div> <div class="control"> <label class="label is-small">&nbsp;</label> <button class="button is-small {is-info:!refreshNeeded,is-warning:refreshNeeded}" onclick="{refreshAudience}">Refresh</button> <button class="button is-small {is-info:!refreshNeeded,is-warning:refreshNeeded}" onclick="{refreshAudienceNarrow}">Without background</button> </div> </div> <h4 class="title is-6 break">Visitors and pageviews</h4> <div style="width:100%;height:300px;max-width:90vw;max-height:90vh;margin-bottom:2em" ref="chart_daily"></div> <div class="columns"> <div class="column"> <label class="label is-small">Visitors</label> <proptable if="{table_daily}" prop="visitors" ref="table_daily" tabledata="{table_daily}" sum_cols="1"></proptable> </div> <div class="column"> <label class="label is-small">Pageviews</label> <proptable if="{table_pageviews}" prop="pageviews" ref="table_pageviews" tabledata="{table_pageviews}" sum_cols="1"></proptable> </div> </div> <h4 class="title is-6 break">Site and pages</h4> <div class="columns"> <div class="column"> <label class="label is-small">Sites</label> <proptable if="{table_sites}" prop="visitors" ref="table_sites" tabledata="{table_sites}" sum_cols="1"></proptable> </div> <div class="column"> <label class="label is-small">Pages</label> <proptable if="{table_pages}" prop="pageviews" ref="table_pages" tabledata="{table_pages}" sum_cols="1"></proptable> </div> </div> <div class="columns break"> <div class="column is-7"> <h4 class="title is-6">Age and Gender</h4> <div style="width:100%;height:400px;max-width:90vw;max-height:90vh;margin-bottom:2em" ref="chart_genderage"></div> <label class="label is-small">All Visitors</label> <proptable if="{table_genderage}" ref="table_genderage" prop="genderage_all" tabledata="{table_genderage}" sum_rows="1" sum_cols="1"></proptable> <label class="label is-small">Selected Visitors</label> <proptable if="{table_genderage_filtered}" ref="table_genderage_filtered" prop="genderage_filtered" tabledata="{table_genderage_filtered}" sum_rows="1" sum_cols="1"></proptable> </div> <div class="column is-5"> <h4 class="title is-6">Education</h4> <div style="width:100%;height:200px;max-width:90vw;max-height:90vh;margin-bottom:2em" ref="chart_education"></div> <proptable if="{table_education}" prop="education" ref="table_education" tabledata="{table_education}" sum_rows="1"></proptable> <h4 class="title is-6">Partnership</h4> <div style="width:100%;height:200px;max-width:90vw;max-height:90vh;margin-bottom:2em" ref="chart_partnership"></div> <proptable if="{table_partnership}" prop="partnership" ref="table_partnership" tabledata="{table_partnership}" sum_rows="1"></proptable> </div> </div> <h4 class="title is-6">Regions</h4> <div style="width:100%;height:400px;max-width:90vw;max-height:90vh;margin-bottom:2em" ref="chart_map"></div> <div class="columns break"> <div class="column"> <label class="label is-small">Regions</label> <proptable if="{table_regions}" ref="table_regions" prop="regions" tabledata="{table_regions}" sum_cols="1"></proptable> </div> <div class="column"> <label class="label is-small">Countries</label> <proptable if="{table_countries}" ref="table_countries" prop="countries" tabledata="{table_countries}" sum_cols="1"></proptable> </div> </div> <div class="columns break"> <div class="column is-6"> <h4 class="title is-6">Device types</h4> <div style="width:100%;height:200px;max-width:90vw;max-height:90vh;margin-bottom:2em" ref="chart_device_type"></div> <proptable if="{table_device_type}" ref="table_device_type" prop="device_type" tabledata="{table_device_type}" sum_rows="1"></proptable> </div> <div class="column is-6"> <h4 class="title is-6">Browsers</h4> <proptable if="{table_browser}" ref="table_browser" prop="browsers" tabledata="{table_browser}" sum_cols="1"></proptable> </div> </div> <h4 class="title is-6 break">BEX categories</h4> <div class="buttons" if="{bex_scope.length}"> <span class="button" each="{scope,idx in bex_scope}" onclick="{setScope(idx)}"><span>{scope}</span> <span class="icon is-small"><i class="fa fa-times"></i></span></span> </div> <div style="width:100%;max-width:90vw" ref="chart_bex"></div> <h4 class="is-6 title break">Significant interests</h4> <proptable if="{significant_terms}" ref="significant_terms" prop="interests" tabledata="{significant_terms}"></proptable> <h4 class="is-6 title">Extra interests</h4> <proptable if="{extra_terms}" ref="extra_terms" prop="extra" tabledata="{extra_terms}"></proptable> <h4 class="is-6 title">Top interests <button class="button is-small {is-primary:tier2}" onclick="{toggleTier}">Show Tier2</button></h4> <proptable if="{root_terms}" ref="root_terms" prop="tier1" tabledata="{root_terms}"></proptable> </div> </div> <div class="field is-grouped is-grouped-centered"> <div class="control"> <button class="button is-info" onclick="{saveAudience}">Save changes</button> </div><div class="control"> <button class="button is-light" onclick="{removeAudience}">Remove audience</button> </div> </div> </form> </div> </div>', '', '', function(opts) {

  echarts.use([GridComponent,LegendComponent])

  const self = this,
      now = new Date(),
      day = now.getDate(),
      month = now.getMonth(),
      year = now.getFullYear(),
      today = new Date(year,month,day,12),
      ago = (days,fromdate=new Date()) => new Date(fromdate.valueOf() - days*24*3600*1000),
      month_start = new Date(year,month,1,12),
      last_start = month>0 ? new Date(year,month-1,1,12) : new Date(year-1,12+month-1,1,12),
      last_end = new Date(month_start.valueOf() - 24*3600*1000),
      dtstart = ago(15),
      dtend = today,
      dtcustom = '15'

  let measures = api.get('measures'),
      stats = {},
      stats_bex = {},
  		filtered_stats = {},
  		filtered_stats_bex = {},
  		daily = {},
  		filtered_daily = {}

	self.bex_scope = []
  self.allprops = {}
  self.active_nodes = {}
  self.total = 0
  self.total_filtered = 0
  self.term_frequency = 1
  self.refreshNeeded = 0
  self.customers = []

	self.properties = [];

  self.on('mount',() => {
	core.customerAPI.GetOrSet()
		.then(customers => {
			self.customers = customers;

			return api.service('campaigns').find({query:{"segments.profile_id":self._id}})
		})
		.then(res => {
		  self.campaigns = res.data
			return api.service('aggregate').find({query:{
			  service: 'widgets',
			  pipe: [
			    {$match:{"segments.profile_id":self._id}},
			    {$lookup:{from:"campaigns",as:"campaign",localField:"_id",foreignField:"target_sites.routes.widget_id"}}
			  ]
			}})
		})
		.then(res => {
		  self.routes = (res || []).map( row => {row.campaign = row.campaign[0]; return row; } )
		  self.update()
		})
		.catch(err => api.emit('toast', { type:'danger', title:'Error fetching customers', content:err.message }));

    self.sites = self.sites || []
    self.properties = self.properties || []
    self.profile = self.profile || {}
    self.iab_filter = self.iab_filter
    self.manual = self.manual || false
    self.dtend = self.dtend ? new Date(self.dtend) : today
    self.dtstart = self.dtstart ? new Date(self.dtstart) : ago(15)
    self.dtcustom = self.dtcustom || '15'
    var props = api.get('properties')
    Object.keys(props).forEach(pkey => {
      const prop = props[pkey]
      Object.keys(prop.measures).forEach(mkey => {
        if (self.properties.indexOf(mkey)>-1) {
          let mes = prop.measures[mkey].parent
          while (mes) {
            if (self.active_nodes[mes.id]) self.active_nodes[mes.id] += 1
            else self.active_nodes[mes.id] = 1
            mes = mes.parent
          }
        }
      })
    })
    self.customer_obj = self.customers.find(c => c._id==self.customer_id)
    self.allprops = props
   	if (self.expanded) self.initChart()
  })

  self.on('update',() => {
    self.dtend = self.dtend ? new Date(self.dtend) : dtend
    self.dtstart = self.dtstart ? new Date(self.dtstart) : dtstart
    self.dtcustom = self.dtcustom || dtcustom
    self.customer_obj = self.customers.find(c => c._id==self.customer_id)
    if (self.refreshNeeded) {
      self.dirty = true
      if (!self.manual) {
        self.setFilter()
        self.setBEXFilter()
      }
    }

    console.log('DATES',typeof self.dtend.toISODate,typeof self.dtstart.toISODate)
    measures = api.get('measures')
    var props = api.get('properties')
    Object.keys(props).forEach(pkey => {
      const prop = props[pkey]
      Object.keys(prop.measures).forEach(mkey => {
        if (self.properties.indexOf(mkey)>-1) {
          let mes = prop.measures[mkey].parent
          while (mes) {
            if (self.active_nodes[mes.id]) self.active_nodes[mes.id] += 1
            else self.active_nodes[mes.id] = 1
            mes = mes.parent
          }
        }
      })
    })
    self.allprops = props
  })

  this.refreshAudienceNarrow = function(e) {
    e.preventDefault()
    self.stats = null
    self.refreshNeeded = 0
    self.adform_status = 'dirty'
    self.fetch_all = false
    self.initChart()
  }.bind(this)

  this.refreshAudience = function(e) {
    e.preventDefault()

    self.stats = null
    self.refreshNeeded = 0
    self.adform_status = 'dirty'
    self.fetch_all = true
    self.initChart()
  }.bind(this)

  this.fetchAdform = function(e) {
    e.preventDefault()
    api.service('stats-adform')
       .find({query:adform_qry})
       .then(r => {
          self.adform_file = r
          self.adform_status = 'progress'
          self.adform_done = 0
          self.adform_export = self.adform_total
          self.dirty = true
          self.update()
       })
       .catch(e => {
          console.log('fetch adform error',e)
          api.emit('toast',{type:'danger',title:'Error removing audience',content:e.message})
       })
  }.bind(this)
  api.service('stats-adform').on('status',function(msg) {
    self.adform_status = msg.status
    self.adform_done = msg.done
    self.adform_export = msg.total
    self.update()
  })

  this.toggleManual = function(e) {
		self.manual = !self.manual
console.log('manual',self.manual)
		self.refreshNeeded++
  }.bind(this)

  this.setCustom = function(e) {
    e.preventDefault()
    self.dtcustom = 'custom'
    var t = e.target,
        ref = t.getAttribute('ref')
    self[ref] = self.refs[ref].value
  }.bind(this)

  this.setCustomDates = function(e) {
    switch (e.target.value) {
      case 'prev_m':
        self.dtstart = self.refs.dtstart.value = last_start.toISOString().replace(/T.*$/,'')
        self.dtend = self.refs.dtend.value = last_end.toISOString().replace(/T.*$/,'')
        break;
      case 'this_m':
        self.dtstart = self.refs.dtstart.value = month_start.toISOString().replace(/T.*$/,'')
        self.dtend = self.refs.dtend.value = today.toISOString().replace(/T.*$/,'')
        break;
      case 'custom':
        break;
      default:
        self.dtstart = self.refs.dtstart.value = ago(e.target.value).toISOString().replace(/T.*$/,'')
        self.dtend = self.refs.dtend.value = today.toISOString().replace(/T.*$/,'')
    }
    self.dtcustom = e.target.value
    self.refreshNeeded++
  }.bind(this)

  this.setFilter = function(e) {
    if (!self.manual) {
      self.refs.filter.value = getFilter()
    } else {
      self.filter = self.refs.filter.value
  		self.refreshNeeded++
    }
  }.bind(this)
  this.setBEXFilter = function(e) {
    if (!self.manual) {
      self.refs.iab_filter.value = getBEXFilter()
    } else {
      self.iab_filter = self.refs.iab_filter.value
  		self.refreshNeeded++
    }
  }.bind(this)

  self.setCustomerFilter = self.parent.setCustomerFilter

  this.togglePrint = function(e) {
		e.preventDefault()
		e.stopPropagation()
		if (self.is_print) {
		  document.body.classList.remove('print')
		  self.is_print = false
		  document.onkeydown = undefined
		} else {
		  document.body.classList.add('print')
		  self.is_print = true
		  api.emit('toast',{type:'info',title:'Press ESC to exit print mode'})
      document.onkeydown = function(e) {
        console.log('key',e.key,e.char)
        if (e.key=='Escape') self.togglePrint(e)
      }
		}
  }.bind(this)

  this.toggleTier = function(e) {
		e.preventDefault()
		self.tier2 = !self.tier2
    const root = self.fetch_all && stats.aggregations.bex.filtered.tags.buckets || [],
          froot = stats.aggregations.filtered.bex.filtered.tags.buckets
    self.root_terms = {
  	  columns:['Interest','all','selected'],
  	  percent_cell:[self.total_profiled,self.total_filtered],
  	  pcell_mode:'col',
  	  percent_col:{label:'% sel/all',all:1,sel:2},
  	  rows: Object.keys(root).filter(k => self.tier2 || !k.match(/\|/)).map(k => [k,root[k].doc_count,froot[k].doc_count||0] )
    }
console.log('tier',self.tier2,self.root_terms)
    self.refs.root_terms.update({tabledata:self.root_terms})
  }.bind(this)

  this.toggleNext = function(e) {
		e.preventDefault()
		const
			el = e.target,
			nxt = el.nextElementSibling
		el.classList.toggle('is-open')
		nxt && nxt.classList.toggle('is-hidden')
  }.bind(this)

	function getFilteredSeries(stats,filter_field,filter_value,group_field,group_values) {
    const series = {},
          field = stats.aggregations[filter_field].buckets.find(k => k.key==filter_value)
    if (!field) return []
    field[group_field].buckets.forEach(b => {series[b.key] = b.doc_count || 0})
		return group_values.map(k => series[k] || 0)
	}

	function getSeries(stats,group_field,group_values) {
    const series = {},
          field = stats.aggregations[group_field]
    if (!field) return []
    field.buckets.forEach(b => {series[b.key] = b.doc_count || 0})
		return group_values.map(k => series[k] || 0)
	}

	function getBexSeries(stats,group_values) {
    const series = {}, buckets = stats.aggregations.bex.filtered.tags.buckets
    Object.keys(buckets).forEach(b => {series[b] = buckets[b].profiles.doc_count || null})
		return group_values.map(k => series[k])
	}
	function getBexLabels(stats) {
    const series = self.fetch_all && stats.aggregations.bex.filtered.tags.buckets || stats.aggregations.filtered.bex.filtered.tags.buckets,
          keys = Object.keys(series),
          skeys = keys.sort((a,b) => series[a].profiles.doc_count>series[b].profiles.doc_count
                                     ? -1
                                     : series[a].profiles.doc_count<series[b].profiles.doc_count
                                     ? 1
                                     : 0)

    return skeys
	}

	function getFilter() {
  	if (self.manual) return self.refs.filter.value
  	let filter_demographics = Object.keys(self.profile).filter(k => (['bex_cats','extra','bex'].indexOf(k)<0)).map( k => {
  	  const l = self.profile[k],
  	        p = k=='bex_cats' ? 'profile.bex' : 'profile.'+k,
  	        v = k=='bex_cats' ? l.map(lv => lv.split(/\|/g).pop()) : l,
  	        s = '(' + p + ':"' + v.join('" OR "') + '")'
      return s
  	}).join(' AND ')

    self.filter = filter_demographics
    return filter_demographics
	}

	function getBEXFilter() {
	  if (self.manual) return self.iab_filter
	  const modes = {should:'', must:'+', not:'-'}
  	let filter_interests = Object.keys(self.profile).filter(k => (['bex_cats','extra','bex'].indexOf(k)>-1)).map( k => {
console.log('inerest',k,self.profile[k])
      return k == 'bex'
               ? self.profile[k].map(s => (modes[s.mode]+s.label+':'+(s.freq || self.term_frequency))).join(' ')
               : self.profile[k].map(s => s+':'+self.term_frequency).join(' ')
  	}).join(' ')
console.log('string iab_filter',filter_interests)
  	self.iab_filter = filter_interests
  	return filter_interests
  }

  function parseBEXFilter() {
	  var src = self.iab_filter,
	      flt = src  ? iab_parse.parse(src) : {}
	  console.log('parsed iab_filter',flt)
	  return flt
	}

  this.initChart = function(e) {
  	e && e.preventDefault()

    const filter = getFilter(),
          iab_filter = getBEXFilter() && parseBEXFilter()

  	let site_filter = ""
  	if (self.sites.length) {
    	site_filter = self.sites.join(' OR ')
  	}
    console.log('filter',filter)

    const profile_fork_qry = []
    if (filter) profile_fork_qry.push(
      { query_string: {query: filter} }
    )
    if (iab_filter) profile_fork_qry.push(
      { bool: iab_filter }
    )

    const profile_fork = profile_fork_qry.length
          ? { bool: { filter: profile_fork_qry } }
          : { exists: {field:'profile.model'} }

  	const
  	  dtend = ago(-1,self.dtend),
  	  daily_agg = self.sites.length
      ?	{"bool": {"must": [
          {"range":{"visited.date":{"gte":self.dtstart,"lte":dtend}}},
          {"terms": {"visited.site":self.sites}}
        ] } }
      : {"range":{"visited.date":{"gte":self.dtstart,"lte":dtend}}}

    const filter_qry = {
      bool: {
        filter: [

          { nested: {
	          path: "visited",
            query: daily_agg
          } }
        ]
      }
    }

    const adform_qry = {
      bool: {
        filter: [

          { nested: {
	          path: "visited",
            query: daily_agg
          } },
          profile_fork
        ]
      }
    }
    window.adform_qry = adform_qry

    self.update()

    preloader.inc()
    var initData = new Promise(function(resolve,reject) {
        if (self.stats) resolve(self.stats)
        else resolve(api.service('stats-profile').find({ query: {filter: filter_qry, agg_filter: daily_agg, fork_filter: profile_fork, term_frequency:self.term_frequency, fetch_all:self.fetch_all} }))
    })
    initData
    .then(res => {
    	stats = res
console.log('filtered profile',stats)
      filtered_stats.aggregations = res.aggregations.filtered
      self.total = stats.hits.total
    	self.total_filtered = filtered_stats.aggregations.doc_count
    	self.total_filtered_profiled = filtered_stats.aggregations.reach.value
    	self.adform_total = self.fetch_all && stats.aggregations.adform.reach.value || 0
    	self.adform_filtered = filtered_stats.aggregations.adform.reach.value
    	const toptags = res.aggregations.filtered.bex.filtered.toptags.buckets
    	self.significant_terms = {
    	  columns:['Interest','Count','Rank'],
  	    percent_cell:self.total_filtered,
	  	  pcell_mode:'none',
    	  rows: toptags.map(k => [k.key.replace('bex','').replace(/_/g,' '),k.profiles.doc_count,k.score])
      }
      const extra = self.fetch_all && res.aggregations.extra.tags.buckets || [],
            fextra = res.aggregations.filtered.extra.tags.buckets,
            fextramap = {}
      fextra.forEach(b => fextramap[b.key] = b.profiles.doc_count)
    	self.extra_terms = {
    	  columns:['Interest','all','selected'],
  	    percent_cell:[self.total_profiled,self.total_filtered],
	  	  pcell_mode:'col',
        percent_col:{label:"% sel/all",all:1,sel:2},
    	  rows: extra.map(k => [k.key.replace('extra','').replace(/_/g,' '),k.profiles.doc_count,fextramap[k.key]||0])
      }
      const root = self.fetch_all && res.aggregations.bex.filtered.tags.buckets || [],
            froot = res.aggregations.filtered.bex.filtered.tags.buckets
      self.root_terms = {
    	  columns:['Interest','all','selected'],
    	  percent_cell:[self.total_profiled,self.total_filtered],
	  	  pcell_mode:'col',
        percent_col:{label:"% sel/all",all:1,sel:2},
    	  rows: Object.keys(root).filter(k => self.tier2 || !k.match(/\|/)).map(k => [k,root[k].profiles.doc_count,froot[k].profiles.doc_count||0] )
      }
      const browsers = res.aggregations.browser.buckets,
            fbrowsers = res.aggregations.filtered.browser.buckets
      let fmap = {}
      fbrowsers.forEach(b => fmap[b.key] = b.doc_count)
      self.table_browser = {
        columns:["Browser","all","selected"],
  	    percent_cell:[self.total,self.total_filtered],
	  	  pcell_mode:'col',
        percent_col:{label:"% sel/all",all:1,sel:2},
        rows: browsers.map(b => [ b.key, b.doc_count, fmap[b.key]||0 ])
      }
    	init_genderage()
    	init_simple('education','Education',['low','high'],self.total_profiled)
    	init_simple('partnership','Partnership',['single','in_relationship'],self.total_profiled)
     	init_simple('device_type','Device types',['desktop','phone','tablet','tv','console'],self.total)
     	init_bex()

      daily = stats
    	filtered_daily.aggregations = daily.aggregations.filtered
    	self.pv_total = self.fetch_all && daily.aggregations.pages.date_filtered.pageviews.value || 0
    	self.pv_filtered = daily.aggregations.filtered.pages.date_filtered.pageviews.value
      self.pv_profiled = daily.aggregations.profiled.pages.date_filtered.pageviews.value
      self.total = daily.hits.total
      self.total_filtered = daily.aggregations.filtered.doc_count
      self.total_profiled = daily.aggregations.profiled.doc_count

    	console.log('filtered daily',self.pv_total,self.pv_filtered,stats)
      preloader.dec()
  	  init_daily()
     	init_map()
      const sites = res.aggregations.pages.date_filtered.top_site.buckets,
            fsites = res.aggregations.filtered.pages.date_filtered.top_site.buckets,
            smap = {}
      fsites.forEach(s => smap[s.key] = s.profiles.doc_count)
      self.table_sites = {
        columns:["Sites/Visitors","all","selected"],
  	    percent_cell:[self.total,self.total_filtered],
	  	  pcell_mode:'col',
        percent_col:{label:"% sel/all",all:1,sel:2},
        rows: sites.map(s => [ s.key, s.profiles.doc_count, smap[s.key]||0 ])
      }
      const pages = res.aggregations.pages.date_filtered.top_page.buckets,
            fpages = res.aggregations.filtered.pages.date_filtered.top_page.buckets,
            pmap = {}

      fmap = {}
      fpages.forEach(p => {
        pmap[p.key] = p.profiles.doc_count
        fmap[p.key] = p.pageviews.value
      })
      const keys = pages.map(p => p.key)
      api.service('page').find({query:{page_id:{$in:keys}},$limit:keys.length})
      .then(res => {
        const url = {}
        res.data.forEach(p => {
          url[p.page_id] = p.page_proto + '://' + p.page_url
        })
console.log('top pages',res,url)
        self.table_pages = {
          columns:["Pages/Visitors/Views","all","selected","all","selected"],
    	    percent_cell:[self.total,self.total_filtered,self.pv_total,self.pv_filtered],
	    	  pcell_mode:'col',
          percent_col:{label:"% sel/all",all:1,sel:2},
          rows: pages.map(p => [
            '<a target="_blank" href="'+url[p.key]+'">'+(url[p.key] || 'no url').slice(0,50)+' ('+ p.key + ')</a>',
            p.profiles.doc_count, pmap[p.key]||0, p.pageviews.value, fmap[p.key] || 0])
        }
        self.update()
     	  if (self.refs['table_pages']) self.refs['table_pages'].update({tabledata:self['table_pages']})
      })

     	const tables = ['table_daily','table_pageviews','table_sites','table_regions','table_countries','table_genderage', 'table_genderage_filtered', 'table_education', 'table_partnership', 'table_device', 'table_browser', 'significant_terms', 'extra_terms', 'root_terms']
    	self.update()
     	tables.forEach(table => {
     	  console.log('tlb profil',table,self.refs[table])
     	  if (self.refs[table]) self.refs[table].update({tabledata:self[table]})
     	})
     	preloader.dec()

    })
    .catch(e => {
      console.log('error profile stats',e.message)
      api.emit('toast',{type:'danger',title:'Error fetching data',content:e.message})
      preloader.dec()
    })

  }.bind(this)

  let map_max = 0
	function getRegionSeries(stats) {
    console.log('region stats',stats)
    const series = {}, fseries = {}, countries = {}, fcountries = {},
          buckets = self.fetch_all && stats.aggregations.pages.date_filtered.regions.buckets || [],
          fbuckets = stats.aggregations.filtered.pages.date_filtered.regions.buckets
    buckets.forEach(b => {
    	const p = b.key.split(/\|/g)
    	let idx = p[0]
    	countries[idx] = +(countries[idx] || 0) + b.profiles.doc_count
    	if (idx=='Slovenia') {
    	  idx = p[1] || p[0]
        if (idx=='Jugovzhodna Slovenija') idx = 'Dolenjska'
      	series[idx] = +(series[idx] || 0) + b.profiles.doc_count
      }
    })
    fbuckets.forEach(b => {
    	const p = b.key.split(/\|/g)
    	let idx = p[0]
    	fcountries[idx] = +(fcountries[idx] || 0) + b.profiles.doc_count
    	if (idx=='Slovenia') {
    	  idx = p[1] || p[0]
        if (idx=='Jugovzhodna Slovenija') idx = 'Dolenjska'
      	fseries[idx] = +(fseries[idx] || 0) + b.profiles.doc_count
      }
    })
    self.table_regions = {
      columns:["Region","all","selected"],
	    percent_cell:[self.total,self.total_filtered],
      percent_col:{label:"% sel/all",all:1,sel:2},
  	  pcell_mode:'col',
      rows: Object.keys(series).map(k => [k,series[k],fseries[k] || 0])
    }
    self.table_countries = {
      columns:["Country","all","selected"],
	    percent_cell:[self.total,self.total_filtered],
      percent_col:{label:"% sel/all",all:1,sel:2},
  	  pcell_mode:'col',
      rows: Object.keys(countries).map(k => [k,countries[k],fcountries[k] || 0])
    }
    map_max = 0
    const out = Object.keys(fseries).map( k => {
      map_max = Math.max(map_max,fseries[k])
      return {name:k,value:fseries[k]}
    })
    console.log('region series',map_max,out)
		return out
	}

  function init_map() {

    echarts.registerMap('slovenia', geojson);
  	const data = getRegionSeries(daily),
  	      options = {
  					tooltip: {},
						visualMap: {

								max: map_max,
								left: 'left',
								top: 'center',
				        text: [map_max,'0'],
								seriesIndex: [0],
								inRange: {
								    color: ['#e0ffff', '#006edd']
								}
						},
						geo: [{
							map: 'slovenia',
						  label: {
						      normal: {
						          show: true,
						          textStyle: {
						              color: 'rgba(0,0,0,0.4)'
						          }
						      }
						  },
						  itemStyle: {
						      normal:{
						          borderColor: 'rgba(0, 0, 0, 0.2)'
						      },
						      emphasis:{
						          areaColor: null,
						          shadowOffsetX: 0,
						          shadowOffsetY: 0,
						          shadowBlur: 20,
						          borderWidth: 0,
						          shadowColor: 'rgba(0, 0, 0, 0.5)'
						      }
						  }
					  }],
				    grid: [
					    {x: '0%', y:'0%', width: '100%',height:'100%'}
				    ],
						series: [{
						  name:'Region',
							type:'map',
							geoIndex: 0,
							data: data
						}]
					}

	  let chart = echarts.getInstanceByDom(self.refs.chart_map)
		if (!chart) chart = echarts.init(self.refs.chart_map,'light')

    chart.setOption(options)

  }

  function init_genderage() {

	  const
	    labels = [ '10-17','18-24','25-29','30-39','40-49','50-59','60+'],
	    data_female_filtered = getFilteredSeries(filtered_stats,'gender','female','age',labels),
	    data_female = self.fetch_all && getFilteredSeries(stats,'gender','female','age',labels) || [],
	    data_male_filtered = getFilteredSeries(filtered_stats,'gender','male','age',labels),
	    data_male = self.fetch_all && getFilteredSeries(stats,'gender','male','age',labels) || [],
	    data_max_plain = Math.max(...[].concat(data_female,data_female_filtered,data_male,data_male_filtered)),
	    data_max = Math.pow(10,(1 + Math.floor(Math.log10(data_max_plain))))

	    self.table_genderage = {
	      columns: ['gender/age'].concat(labels),
	      percent_cell:self.total_profiled,
  	    pcell_mode:'none',
	      rows: [
	        ['Women'].concat(data_female),
	        ['Men'].concat(data_male)
	      ]
	    }
	    self.table_genderage_filtered = {
	      columns: ['gender/age'].concat(labels),
  	    percent_cell:self.total_filtered,
  	    pcell_mode:'none',
	      rows: [
	        ['Women'].concat(data_female_filtered),
	        ['Men'].concat(data_male_filtered),
	      ]
	    }

console.log('data_max',data_max_plain,data_max)

	  const
	    options = {
				tooltip : {
					trigger: 'axis',
					axisPointer : {
				    type : 'shadow'
					}
				},
				legend: {
					data: ['All women', 'Selected women','All men','Selected men']
				},
				grid: [
					{x: '2%', y:'7%', width: '98%',height:'40%',containLabel:true},
					{x: '2%', y:'48%', width: '98%',height:'40%',containLabel:true},
				],
				xAxis: [
					{type:'category',gridIndex: 0, data:labels, name:'Age',nameLocation:'start',nameTextStyle:{padding:[28,0,0,0],fontWeight:'bold'}},
					{type:'category',gridIndex: 1, data:labels, axisLabel:{show:false}},
				],
				yAxis: [
					{type:'log',min:1,gridIndex: 0, max:data_max, name:'Men', axisLabel:{showMinLabel:false},nameTextStyle:{fontWeight:'bold'}},
					{type:'log',min:1,gridIndex: 1, max:data_max, inverse:true, name:'Women', axisLabel:{showMinLabel:false},nameTextStyle:{fontWeight:'bold'}},
				],
				series: [
					{
					    name: 'Selected women',
					    type: 'bar',
					    label: {
					        normal: {
					            show: true,
					            position: 'inside'
					        }
					    },
					    barWidth:60,
					    z:10,
					    yAxisIndex:1,
					    xAxisIndex:1,
					    data: data_female_filtered
					},
					{
					    name: 'All women',
					    type: 'bar',
					    stack: '',
					    label: {
					        normal: {
					            show: true,
					            position: 'insideBottom'
					        }
					    },
					    itemStyle:{
					       color:'#aaa'
					    },
					    barWidth:70,
					    barGap:'-107%',
					    yAxisIndex:1,
					    xAxisIndex:1,
					    data: data_female
					},
					{
					    name: 'Selected men',
					    type: 'bar',
					    label: {
					        normal: {
					            show: true,
					            position: 'inside'
					        }
					    },
					    z:10,
					    barWidth:60,
					    yAxisIndex:0,
					    xAxisIndex:0,
					    data: data_male_filtered
					},
					{
					    name: 'All men',
					    type: 'bar',
					    label: {
					        normal: {
					            show: true,
					            position: 'inside'
					        }
					    },
					      itemStyle:{
					       color:'#aaa'
					    },
					    barWidth:70,
					    barGap:'-107%',
					    yAxisIndex:0,
					    xAxisIndex:0,
					  data: data_male
					}
				]
			}

	  let chart = echarts.getInstanceByDom(self.refs.chart_genderage)
		if (!chart) chart = echarts.init(self.refs.chart_genderage,'light')

    chart.setOption(options)

  }

  function init_bex() {

	  const
	    scope = self.bex_scope,
	    filter = scope.join('|'),
	    depth = scope.length+1,
	    datalabels = getBexLabels(stats).filter(f => {
	      const l = f.split(/\|/g)
	      if (l.length!=depth) return false
	      return filter.length ? f.indexOf(filter+'|')==0 : true
	    }),
	    labels = datalabels.map( l => l.split(/\|/g).pop() )

    self.refs.chart_bex.style.height = (50*labels.length)+'px'

	  const
	    options = {
				tooltip : {
					trigger: 'axis',
					axisPointer : {
				    type : 'shadow'
					}
				},
				grid: [
					{x: '2%', y:'6%', width: '98%',height:'94%',containLabel:true}
				],
				yAxis: [
					{type:'category', data:labels, inverse:'true'},
				],
				xAxis: [
					{type:'log',axisLabel: {showMaxLabel:false}, position:'top'},
				],
				series: [
					{
					    name: 'Selected',
					    type: 'bar',
					    label: {
					        normal: {
					            show: true,
					            position: 'inside'
					        }
					    },
					    barWidth:"60%",
					    barGap:0,
					    z:10,
					    data: getBexSeries(filtered_stats,datalabels)
					},
					{
					    name: 'All',
					    type: 'bar',
					    stack: '',
					    label: {
					        normal: {
					            show: true,
					            position: 'insideBottom'
					        }
					    },
					    itemStyle:{
					       color:'#aaa'
					    },
					    barWidth:"73%",
					    barGap:"-110%",
					    data: self.fetch_all && getBexSeries(stats,datalabels) || []
					},
				]
			}

	  let chart = echarts.getInstanceByDom(self.refs.chart_bex),
	      first = 'repeat'
		if (!chart) {
		  first = 'first'
		  chart = echarts.init(self.refs.chart_bex,'light')
      chart.on('click', function (params) {
        if (self.bex_scope.indexOf(params.name)<0) self.bex_scope.push(params.name)
        console.log('bex_scope',self.bex_scope)
        self.update()
        setTimeout(() => init_bex(),100)
      });
    } else {
      chart.resize()
    }
    chart.setOption(options)

  }

  this.setScope = function(idx) {
    return (e) => {

      e.preventDefault()
      self.bex_scope = self.bex_scope.slice(0,idx)
      init_bex()
    }
  }.bind(this)

  function init_simple(prop,name,labels,total) {

    const
      data_prop_filtered = getSeries(filtered_stats,prop,labels),
      data_prop = self.fetch_all && getSeries(stats,prop,labels) | []

    self['table_'+prop] = {
      columns: [name].concat(labels),
	    percent_cell:[total || self.total_profiled,self.total_filtered],
  	  pcell_mode:'row',
      percent_row:{label:"% sel/all",all:0,sel:1},
      rows: [
        ['All'].concat(data_prop),
        ['Selected'].concat(data_prop_filtered)
      ]
    }
    console.log('table_'+prop,self['table_'+prop])

	  const
	    options = {
				tooltip : {
					trigger: 'axis',
					axisPointer : {
				    type : 'shadow'
					}
				},
				legend: {
					data: ['All', 'Selected']
				},
				grid: [
					{x: '2%', y:'6%', width: '98%',height:'88%',containLabel:true}
				],
				xAxis: [
					{type:'category', data:labels},
				],
				yAxis: [
					{type:'log',min:10},
				],
				series: [
					{
					    name: 'Selected',
					    type: 'bar',
					    label: {
					        normal: {
					            show: true,
					            position: 'inside'
					        }
					    },
					    barWidth:60,
					    z:10,
					    data: data_prop_filtered
					},
					{
					    name: 'All',
					    type: 'bar',
					    stack: '',
					    label: {
					        normal: {
					            show: true,
					            position: 'insideBottom'
					        }
					    },
					    itemStyle:{
					       color:'#aaa'
					    },
					    barWidth:70,
					    barGap:'-107%',
					    data: data_prop
					},
				]
			}

	  let chart = echarts.getInstanceByDom(self.refs['chart_'+prop])
		if (!chart) chart = echarts.init(self.refs['chart_'+prop],'light')

    chart.setOption(options)

  }

	function getDailySeries(stats) {
	  const series = []
console.log('getting daily series',stats)
	  stats.aggregations.pages.date_filtered.datum.buckets.forEach( b => series.push([b.key_as_string.replace(/T.*$/,''),b.profiles.doc_count]) )
	  return series
	}

	function getDailyPageviews(stats) {
	  const series = []
console.log('getting pageview series',stats)
	  stats.aggregations.pages.date_filtered.datum.buckets.forEach( b => series.push([b.key_as_string.replace(/T.*$/,''),b.pageviews.value]) )
	  return series
	}

  function init_daily() {
    const visitors = self.fetch_all && getDailySeries(daily ) || [],
          visitors_filtered = getDailySeries(filtered_daily),
          pageviews = self.fetch_all && getDailyPageviews(daily) || [],
          pageviews_filtered = getDailyPageviews(filtered_daily)

    self.table_daily = {
      columns: ["Date/Visitors","all","selected"],
      percent_col:{label:"% sel/all",all:1,sel:2},
      rows: visitors.map((v,idx) => {
        const f = visitors_filtered[idx] && visitors_filtered[idx][1] || 0
        return [ v[0], v[1], f]
      })
    }

    self.table_pageviews = {
      columns: ["Date/Pageviews","all","selected"],
      percent_col:{label:"% sel/all",all:1,sel:2},
      rows: pageviews.map((v,idx) => {
        const f = pageviews_filtered[idx] && pageviews_filtered[idx][1] || 0
        return [ v[0], v[1], f]
      })
    }

	  const options = {
      xAxis: {
        type: 'time',
        axisLabel:{showMinLabel:false,showMaxLabel:false}
      },
      yAxis: [
				{type:'value',name:'Visitors',nameLocation:'end',nameTextStyle:{fontWeight:'bold'}},
				{type:'value',name:'Pageviews',nameLocation:'end', nameTextStyle:{fontWeight:'bold'}}
      ],
      tooltip: {
        trigger: 'axis'
      },
			legend: {
				data: ['All visitors', 'Selected visitors','All pageviews', 'Selected pageviews']
			},
			grid: [
				{x: '2%', y:'15%', width: '98%',height:'85%',containLabel:true}
			],
      series: [
        { type: "line", name: "All visitors", areaStyle:{}, data: visitors },
        { type: "line", name: "Selected visitors", areaStyle:{}, data: visitors_filtered },
        { type: "line", yAxisIndex:1, name: "All pageviews", data: pageviews },
        { type: "line", yAxisIndex:1, name: "Selected pageviews", data: pageviews_filtered },
      ]
    };

    console.log('DIALY',visitors)

	  let chart = echarts.getInstanceByDom(self.refs['chart_daily'])
		if (!chart) chart = echarts.init(self.refs['chart_daily'],'light')

    chart.setOption(options)

  }

  this.toggleExpand = function(e) {
    e.preventDefault()
    e.stopPropagation()
    self.expanded = !self.expanded
    if (self.expanded) setTimeout(() => self.initChart(),100)
  }.bind(this)

  this.removeAudience = function(e) {
    e.preventDefault();
    if (self.campaigns.length || self.routes.length) return api.emit('toast',{type:'danger',title:'Error removing audience',content:'Unlink audience from campaigns/routes'})
    console.log("removing audience", self._id)
    api.service('audiences').remove(self._id)
    .then( r => api.emit('toast',{type:'info',title:`Audience ${r.name} removed`}) )
    .catch( e => api.emit('toast',{type:'danger',title:'Error removing audience',content:e.message}) )
  }.bind(this)

  this.setFreq = function(e) {
    e.preventDefault()
    self.term_frequency = +self.refs.term_frequency.value.trim()
    self.refreshNeeded++
  }.bind(this)

  this.setSites = function(e) {
    e.preventDefault()
    const val = self.refs.sites.value.trim()
    if (val) self.sites = val.split(/\n/g).map(m => m.trim())
    else self.sites = []
console.log('SITES',self.sites)
    self.refreshNeeded++
  }.bind(this)

  this.saveAudience = function(e) {
    e.preventDefault()
console.log('REFS',self.sites)
    const customer_id = self.refs.customer.value,
          customer = self.customers.find(c => c._id==customer_id),
          c = {
            name:self.refs.name.value,
            keyword:self.refs.keyword.value,
            owner:customer.owner,
            customer_id:customer._id.toString(),
            sites:self.sites,
            properties:self.properties,
            profile:self.profile,
            filter:self.filter,
            iab_filter:self.iab_filter,
            manual:self.manual,
            term_frequency:self.term_frequency,
            stats: stats,
            dtstart: self.dtstart,
            dtend: self.dtend,
            dtcustom: self.dtcustom,
            adform_file:self.adform_file,
            adform_status:self.adform_status,
            adform_done:self.adform_done,
            adform_total:self.adform_total,
          }
console.log('saving',c)
    api.service('audiences')
    .patch(self._id,c)
    .then(r => {
      self.dirty = false
      self.parent.update()
      self.update()
      api.emit('toast',{type:'info',title:`Audience ${c.name} stored`})
    })
    .catch(e => api.emit('toast',{type:'danger',title:'Error saving audience',content:e.message}) )
  }.bind(this)
});

